import { Session } from "@supabase/supabase-js";

import { supabaseClient } from "@/services/supabase";

export const AuthApi = {
  subscribeToAuthStateChange: (
    onSession: (session: Session | null) => void,
  ) => {
    // Initial check
    void supabaseClient.auth.getSession().then(({ data }) => {
      onSession(data.session);
    });

    // Listen for changes
    const { data } = supabaseClient.auth.onAuthStateChange(
      (_event, session) => {
        onSession(session);
      },
    );

    // Return the subscription to unsubscribe later
    return data.subscription;
  },
  signInWithOtp: async (email: string) => {
    const { data, error } = await supabaseClient.auth.signInWithOtp({
      email,
      options: {
        shouldCreateUser: false,
      },
    });

    if (error) {
      throw new Error(error.message);
    }

    return data;
  },
  verifyOtp: async ({ email, otp }: { email: string; otp: string }) => {
    const { error } = await supabaseClient.auth.verifyOtp({
      email,
      token: otp,
      type: "email",
    });

    if (error) {
      throw new Error(error.message);
    }
  },
  signOut: () => supabaseClient.auth.signOut(),
};
